/* global axios */
import ApiClient from '../ApiClient';

class CaptainMcpTools extends ApiClient {
  constructor() {
    super('captain/mcp_connectors', { accountScoped: true });
  }

  getTools(connectorId, { page = 1 } = {}) {
    return axios.get(`${this.url}/${connectorId}/mcp_tools`, {
      params: { page },
    });
  }

  updateTool(connectorId, toolId, data) {
    return axios.patch(`${this.url}/${connectorId}/mcp_tools/${toolId}`, {
      mcp_tool: data,
    });
  }
}

export default new CaptainMcpTools();
